import { render, staticRenderFns } from "./EnterMarksSheetRecord.vue?vue&type=template&id=6ce59d4a&scoped=true"
import script from "./EnterMarksSheetRecord.vue?vue&type=script&lang=js"
export * from "./EnterMarksSheetRecord.vue?vue&type=script&lang=js"
import style0 from "./EnterMarksSheetRecord.vue?vue&type=style&index=0&id=6ce59d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce59d4a",
  null
  
)

export default component.exports